import cn from "classnames";
import { type ComponentPropsWithoutRef, type PropsWithChildren } from "react";
import CallToAction from "@/components/site-builder/CallToAction";
import { FlexPosition } from "@/constants/content";
import { getFlexPositionClassName } from "@/utils/style/getFlexPositionClassName";
import type { SiteBuilderCallToAction } from "@/types/call-to-action";
import s from "./CallToActionGroup.module.css";

export interface CallToActionGroupProps
  extends ComponentPropsWithoutRef<"div"> {
  buttons?: SiteBuilderCallToAction[];
  position?: FlexPosition;
}

export default function CallToActionGroup(
  props: PropsWithChildren<CallToActionGroupProps>,
) {
  const {
    buttons = [],
    position = FlexPosition.Left,
    children,
    ...restProps
  } = props;
  let buttonsContent = children;

  if (buttons.length > 0) {
    const hasButtons = buttons.some((button) => button.shown);

    if (!hasButtons) return null;

    buttonsContent = buttons.map((buttonConfig, index) => (
      <CallToAction key={index} config={buttonConfig} />
    ));
  }

  const className = cn(
    s.wrapper,
    restProps.className,
    "informa-button-group",
    getFlexPositionClassName(position),
  );

  return (
    <div {...restProps} className={className}>
      {buttonsContent}
    </div>
  );
}
